export default __webpack_public_path__ + "static/media/number4.279dc45b.svg";